export const getHomeContent = (state) => state.Content.home;

export const getImprintContent = (state) => state.Content.imprint;

export const getDataPolicyContent = (state) => state.Content.dataPolicy;